import {combineReducers} from 'redux';
import PreviewQuestionReducer
  from './preview_question_reducer/PreviewQuestionReducer';

export default combineReducers({
  previewQuestion: PreviewQuestionReducer,
});
